/** "Scanned · MTN693003 · just now" (18 #10) — on the sheet / row a scan opened. */
import { useEffect, useState } from 'react';
import { ScanBarcode } from 'lucide-react';
import { formatTimeAgo } from '@/lib/format';

export default function ScannedStrip({ scanned }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => tick((value) => value + 1), 30000);
    return () => clearInterval(timer);
  }, []);
  if (!scanned) return null;
  const ago = Date.now() - scanned.at < 60000 ? 'just now' : formatTimeAgo(new Date(scanned.at).toISOString());
  return (
    <p className="flex items-center gap-2 rounded-xl bg-status-green-bg px-3 py-2 text-[13.5px] font-semibold text-status-green-ink" data-testid="stock-scanned-strip">
      <ScanBarcode className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate">{scanned.source === 'manual' ? 'Typed' : 'Scanned'} · <span className="font-mono">{scanned.code}</span></span>
      <span className="shrink-0 text-[12.5px] font-medium">{ago}</span>
    </p>
  );
}

